<template>
  <div class="scratchHome">
    <div class="items">
      <div class="item" v-for="(item) in data" :key="item.pk">
        <ActivityItem :dic="item" />
        <div id="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { IMG_BANNER, IMG_SCRATCH_ICON } from "@/assets";
import { Utils } from "@/utils";

import ActivityItem from "./components/ActivityItem.vue";
import { types as ActivityTypes } from "@/store/modules/activity.js";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "ActivityHome",
  components: {
    ActivityItem
  },
  data() {
    return {
      images: {
        banner: IMG_BANNER,
        icon: IMG_SCRATCH_ICON
      }
    };
  },
  computed: {
    ...mapState({
      page: state => state.activity.activity.page,
      load_more: state => state.activity.activity.load_more,
      data: state => state.activity.activity.data
    })
  },

  methods: {
    ...mapActions({
      fetchData: ActivityTypes.FETCH_LIST_ACTIVITY
    }),
    ...Utils,
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }

      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchData({ page: that.page + 1 });
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    this.fetchData({ page: 1 });
  }
};
</script>

<style lang="less" scoped>
.scratchHome {
  .ad {
    cursor: pointer;
    margin: 10px;
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .courseView {
    background-color: #f8f8f8;
    border-radius: 4px;
    margin: 10px;
    padding: 10px;
    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        flex-direction: row;
        align-items: center;
        .icon {
          width: 30px;
          // height: 25px;
        }
        .text {
          color: #333333;
          margin-left: 10px;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
    .items {
      display: flex;
      flex-direction: row;
      margin: 10px 0;
      margin-left: -10px;
      margin-bottom: 0;
      min-height: 120px;
      flex-wrap: wrap;
      .item {
        width: calc(100% / 3 - 12px);
        margin-left: 10px;
        margin-bottom: 10px;
        border: solid 1px #ebebeb;
        cursor: pointer;
        background-color: #ffffff;
        border-radius: 4px;
        overflow: hidden;
        &.four_item {
          width: calc(100% / 4 - 12px);
        }
      }
    }
    .footer {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      .text {
        color: #6b45e1;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
}
#line {
  height: 1px;
  background-color: #ebebeb;
  width: 93%;
  margin: -10px auto 15px;
}
.item:nth-child(4) #line {
  display: none;
}
</style>
